import Menu from '@/components/menu_component.vue';
import Reports from '@/components/customer_reports_component.vue';
import CompareReports from '@/components/comparison_reports_component.vue' 
import LoaderPopover from '@/components/loaderpopover_component.vue';
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import XLSX from 'xlsx';
export default {
    name: 'reports',
    data() {
        return {
            dates_selected : [],
            salons:[],
            salon_selected:'',
            reports_data:[],
            selected_category : 'Booked',
            page_title:'',
            show_booked_info:true,
            show_new_info:false,
            show_returning_info:false,
            show_vip_info:false,
            show_risk_info:false,
            download_file_name:'',
            show_customer_reports:false,
            show_revenue_reports:true,
            show_compare_reports:false,
            show_services_info:true,
            show_classes_info:false,
            show_products_info:false,
            show_stylists_info:false,
            compare_customer_data:[],
            compare_revenue_data:[],
            select_period_type:'period',
            report_type : '',
            selected_revenue_type : ''
        }
    },
    computed:{
        diff_dates(){
            let start = moment(this.dates_selected[0]).format('DD-MM-YYYY');
            let end = moment(this.dates_selected[1]).format('DD-MM-YYYY');
            return moment(end,'DD-MM-YYYY').diff( moment(start, 'DD-MM-YYYY') , 'days');
        }
    },
    components: {
        Menu,
        Reports,
        LoaderPopover,
        DatePicker,
        CompareReports
    },
    async created(){
        this.salon_selected=this.$session.get('store_id')
        await this.getStore();
        if(this.$session.has('reports_obj')){
            var reports_obj = this.$session.get('reports_obj')
            this.salon_selected = reports_obj.selected_store;
            this.dates_selected = reports_obj.selected_dates;
            if(reports_obj.type == 'customer'){
                this.page_title = 'Customer Reports'
                this.show_customer_reports = true;
                this.show_revenue_reports = false;
                this.get_reports(reports_obj.subtype);
                this.report_type = 'Customer Reports';
                this.selected_revenue_type = reports_obj.type;
            }
            else if(reports_obj.type == 'revenue'){
                this.page_title = 'Revenue Reports'
                this.show_customer_reports = false;
                this.show_revenue_reports = true;
                this.get_reports(reports_obj.subtype)
                this.report_type = 'Revenue Reports';
                this.selected_revenue_type = reports_obj.subtype;
            }
        }
        else {
            this.dates_selected = [moment(new Date(), "DD-MM-YYYY").add(-6, "days").format('MMM D, YYYY'), moment(new Date(), "DD-MM-YYYY").format('MMM D, YYYY')]
            this.page_title = 'Customer Reports'
            this.show_customer_reports = true;
            this.show_revenue_reports = false;
            this.get_reports('Booked')
            this.report_type = 'Customer Reports';
            this.selected_revenue_type = 'Booked';
        }
    },
    beforeDestroy() {
        this.$session.remove('reports_obj');
    },
    methods:{
        compare_dropdown_selection(){
            if(this.diff_dates > 365){
                this.select_period_type = 'period';
            }
        },
        show_compare_report(){
            this.page_title = 'Comparison Reports'
            this.show_compare_reports = false;
            this.show_customer_reports = false;
            this.show_revenue_reports = false;
            this.get_compare_report_data();
        },
        show_revenue_report(){
            this.page_title = 'Revenue Reports'
            this.show_customer_reports = false;
            this.show_revenue_reports = true;
            this.show_compare_reports = false;
            this.get_reports('Services')
            this.report_type = 'Revenue Reports';
            this.selected_revenue_type = 'Services';
        },
        show_customer_report(){
            this.page_title = 'Customer Reports'
            this.show_customer_reports = true;
            this.show_revenue_reports = false;
            this.show_compare_reports = false;
            this.get_reports('Booked')
            this.report_type = 'Customer Reports';
            this.selected_revenue_type = 'Booked';
        },
        download_reports() {
            if(this.reports_data.length){
                var required_data = []
                var data_formate={
                    "Customer Name":"",
                    "Email":"",
                    "Mobile Number":"",
                    "Recent Booking":"",
                    "Total Bookings":"",
                    "Cancelled":"",
                    "No Show":"",
                    "Total Sales":""
                }
                this.reports_data.forEach(record => {
                    data_formate['Customer Name'] = record.book_first_name + ' ' + record.book_last_name;
                    data_formate['Email'] = record.book_email;
                    data_formate['Mobile Number'] = record.book_mobile;
                    data_formate['Recent Booking'] = record.formated_visit_date;
                    data_formate['Total Bookings'] = record.total_visits;
                    data_formate['Cancelled'] = record.cancel;
                    data_formate['No Show'] = record.no_show;
                    data_formate['Total Sales'] = record.total_sales;
                    required_data.push(data_formate);
                    data_formate={
                        "Customer Name":"",
                        "Recent Booking":"",
                        "Total Bookings":"",
                        "Cancelled":"",
                        "No Show":"",
                        "Total Sales":""
                    }
                });
                const data = XLSX.utils.json_to_sheet(required_data)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, data, 'data')
                XLSX.writeFile(wb,this.download_file_name)
            }
            else{
                this.$bvToast.toast('Warning!', {
                    title: 'No Content to export',
                    variant: 'warning',
                    autoHideDelay: 5500,
                    solid: true
                })
            }
          },
        async getStore(){
            await this.$store.dispatch('getStoreByOwnerId',[this.$store.state.api,this.$store.state.user_id]);
            if(Object.keys(this.$store.state.stores_data).length > 0){
                this.salons = this.$store.state.stores_data; 
            }
            if(this.$session.has('reports_obj')){
                var reports_obj = this.$session.get('reports_obj')
                this.salon_selected = reports_obj.selected_store;
            }
            else this.salon_selected = this.$store.state.stores_data[0].store_id;
        },
        changed_date(){
            this.compare_dropdown_selection();
            if(this.show_compare_reports){
                this.get_compare_report_data()
            }
            else this.get_reports(this.selected_category)
        },
        get_reports(type){
            if(this.show_compare_reports){
                this.get_compare_report_data()
            }
            else{
                this.$session.set("updated_table_date",true)
                this.selected_category = type;
                this.$store.state.loader_popup = true;
                if(type == 'Booked'){
                    this.show_booked_info = true,
                    this.show_new_info = false,
                    this.show_returning_info = false,
                    this.show_vip_info = false,
                    this.show_risk_info = false
                    this.endpoint = 'servicereport/get_all_customers';
                    this.download_file_name = `Customer_Report_AllCustomers_${moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD')}_${moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')}.xlsx`
                }
                else if(type == 'New')
                {
                    this.show_booked_info = false,
                    this.show_new_info = true,
                    this.show_returning_info = false,
                    this.show_vip_info = false,
                    this.show_risk_info = false
                    this.endpoint = 'servicereport/get_new_customers';
                    this.download_file_name = `Customer_Report_NewCustomers_${moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD')}_${moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')}.xlsx`
                }
                else if(type == 'Returning')
                {
                    this.show_booked_info = false,
                    this.show_new_info = false,
                    this.show_returning_info = true,
                    this.show_vip_info = false,
                    this.show_risk_info = false
                    this.endpoint = 'servicereport/get_returning_customers';
                    this.download_file_name = `Customer_Report_ReturningCustomers_${moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD')}_${moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')}.xlsx`
                }
                else if(type == 'VIP')
                {
                    this.show_booked_info = false,
                    this.show_new_info = false,
                    this.show_returning_info = false,
                    this.show_vip_info = true,
                    this.show_risk_info = false
                    this.endpoint = 'servicereport/get_vip_customers';
                    this.download_file_name = `Customer_Report_VIPCustomers_${moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD')}_${moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')}.xlsx`
                }
                else if(type == 'Risk'){
                    this.show_booked_info = false,
                    this.show_new_info = false,
                    this.show_returning_info = false,
                    this.show_vip_info = false,
                    this.show_risk_info = true
                    this.endpoint = 'servicereport/get_risk_customers';
                    this.download_file_name = `Customer_Report_AtRiskCustomers_${moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD')}_${moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')}.xlsx`
                }
                var revenue_type='';
                this.selected_revenue_type = type;
                if(type == 'Services'){
                    revenue_type = 'service';
                    this.show_services_info = true;
                    this.show_classes_info = false;
                    this.show_products_info = false;
                    this.show_stylists_info = false;
                    this.endpoint = 'servicereport/get_revenue_by_clicking_more';
                }
                else if(type == 'Classes'){
                    revenue_type = 'class';
                    this.show_services_info = false;
                    this.show_classes_info = true;
                    this.show_products_info = false;
                    this.show_stylists_info = false;
                    this.endpoint = 'servicereport/get_revenue_by_clicking_more';
                }
                else if(type == 'Products'){
                    revenue_type = 'product';
                    this.show_services_info = false;
                    this.show_classes_info = false;
                    this.show_products_info = true;
                    this.show_stylists_info = false;
                    this.endpoint = 'servicereport/get_revenue_by_clicking_more';
                }
                else if(type == 'Stylists'){
                    revenue_type = 'stylist';
                    this.show_services_info = false;
                    this.show_classes_info = false;
                    this.show_products_info = false;
                    this.show_stylists_info = true;
                    this.endpoint = 'servicereport/get_revenue_by_clicking_more';
                }
                if(this.endpoint == 'servicereport/get_revenue_by_clicking_more'){
                    axios.post(this.$store.state.api +this.endpoint,{
                        "store_id":this.salon_selected,
                        "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "type":revenue_type,
                    }).then(response => {
                        this.$store.state.loader_popup = false;
                        response.data.result.forEach(record => {
                            record.booked_hrs =  record.booked_hrs/60;
                            var has_decimal = (record.booked_hrs - Math.floor(record.booked_hrs)) !== 0;
                            if(has_decimal) record.booked_hrs = record.booked_hrs.toFixed(2);
                        })
                        this.reports_data = response.data.result;
                    })
                }
                else{
                    axios.post(this.$store.state.api +this.endpoint,{
                        "store_id":this.salon_selected,
                        "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD')
                    }).then(response => {
                        response.data.result.forEach(record => {
                            var current_date = moment(moment(new Date()).format("yyyy-MM-DD"),'yyyy-MM-DD');
                            var booking_date = moment(moment(record.last_booking_date,'yyyy-MM-DD').format("yyyy-MM-DD"),'yyyy-MM-DD');
                            var difference = current_date.diff(booking_date,'d');
                            record.formated_visit_date = moment(record.last_booking_date,'yyyy-MM-DD').format('MMM D, YYYY');
                            record.picture = record.book_first_name[0]+record.book_last_name[0];
                            record.full_name = record.book_first_name+ ' ' +record.book_last_name;
                            record.last_booking_date = difference
                        });
                        this.$store.state.loader_popup = false;
                        this.reports_data = response.data.result;
                    })
                }
            }
        },
        get_compare_report_data(){
            this.show_compare_reports = false;
            this.compare_customer_data = [];
            this.compare_revenue_data = [];
            this.$store.state.loader_popup = true;
            if(this.select_period_type == 'period'){
                axios.post(this.$store.state.api +'servicereport/get_customers_comparison_based_on_salon',{
                    "store_id":this.salon_selected,
                    "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                    "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD'),
                    "compare_to_previous_period":1
                    
                }).then(response => {
                    this.compare_customer_data = response.data.result;
                    axios.post(this.$store.state.api +'servicereport/get_revenue_comparison_based_on_salon',{
                        "store_id":this.salon_selected,
                        "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "compare_to_previous_period":1
                        
                    }).then(response => {
                        this.compare_revenue_data = response.data.result;
                        this.show_compare_reports = true;
                        this.$store.state.loader_popup = false;
                    })
                })
            }
            else{
                axios.post(this.$store.state.api +'servicereport/get_customers_comparison_based_on_salon',{
                    "store_id":this.salon_selected,
                    "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                    "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD'),
                    "compare_to_previous_year": 2
                    
                }).then(response => {
                    // this.$store.state.loader_popup = false;
                    this.compare_customer_data = response.data.result;
                    axios.post(this.$store.state.api +'servicereport/get_revenue_comparison_based_on_salon',{
                        "store_id":this.salon_selected,
                        "start_date":moment(this.dates_selected[0],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "end_date":moment(this.dates_selected[1],'MMM D, YYYY').format('yyyy-MM-DD'),
                        "compare_to_previous_year": 2
                        
                    }).then(response => {
                        this.compare_revenue_data = response.data.result;
                        this.show_compare_reports = true;
                        this.$store.state.loader_popup = false;
                    })
                })
                
            }
        }
    }
}